import type { Notification } from "@circle-react/types/Notification";

import { NotificationItem } from "./NotificationItem";

export interface PageRecordProps {
  lastMarkedAsRead: number | null;
  notification: Notification;
}

export const PageRecord = ({
  notification,
  lastMarkedAsRead,
}: PageRecordProps) => (
  <div className="group flex w-full items-start justify-between rounded-xl px-0 py-2 lg:px-3 lg:hover:bg-hover lg:focus-visible:bg-hover lg:has-[[data-popup-open]]:bg-hover">
    <NotificationItem
      notification={notification}
      lastMarkedAsRead={lastMarkedAsRead}
    />
  </div>
);
